module.exports = __webpack_public_path__ + "static/media/STOUT-final.a445f239.jpg";